import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicIOFundamentals = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="I/O Fundamentals: Handshaking & Buffering"
      videos={[
        "https://www.youtube.com/embed/EHdi72VVvB4",
        "https://www.youtube.com/embed/t2GvlKhT9tY",
        "https://www.youtube.com/embed/1cSou52VdE0"
      ]}
      takeaways={[
        { text: "Learn timing diagrams, block diagrams, and sequence of events." },
        { text: "Understand the advantages and disadvantages of each method." },
        { text: "Learn how one method overcomes the disadvantages of another." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicIOFundamentals;
